import { StateService } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";
import { Comment } from "@webapp/comments";
import { Kpi } from "@webapp/kpis/models/kpis.models";
import { KpiChartCommentData } from "../../kpi-details/kpi-chart/kpi-chart.models";
import { KpiDetailsStateService } from "../../kpi-details/services/kpi-details-state.service";
import { shouldShowInfoIcon } from "../utils";

@Component({
  selector: "add-first-comment",
  templateUrl: "add-first-comment.component.html",
  styleUrls: ["add-first-comment.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddFirstCommentComponent implements OnChanges {
  @Input() public kpi: Kpi;
  @Input() public commentData: KpiChartCommentData;
  public showInfoIcon = false;
  public metadata: { [key: string]: string } = { from: "chart" };

  constructor(private stateService: StateService, private kpiDetailsStateService: KpiDetailsStateService) {}

  public ngOnChanges(): void {
    this.showInfoIcon = shouldShowInfoIcon(this.commentData.targetType, this.commentData.targetDate);
  }

  public onCancel(): void {
    this.kpiDetailsStateService.hideAddFirstCommentView();
  }

  public onCommentCreated(comment: Comment): void {
    this.stateService.go(".comment", { commentId: comment.id });
    this.kpiDetailsStateService.onCommentCreated(this.kpi.id);
    this.kpiDetailsStateService.hideAddFirstCommentView();
  }
}
